import { useEffect, useRef, useState } from 'react';
import 'moment-timezone';
import '../../assets/css/timeline.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  getMQTTConnection,
  getPlatformInfo,
  setRemoteStream,
  setRemoteStreamAudio,
  setIsActiveStream,
  getOfferRecivedStatus,
  setOfferrecived,
  setCodecNotSupported,
  getRemoteStreamAudio,
  getStreamLoader,
} from '../../store/reducers/StreamingReducer';
import { publishWithMQTT } from '../../utils/connection/mqttConnection';
import { getAccountId } from '../../store/reducers/AccountReducer';
import { Utils, constants } from '../../helpers';
import RegionSelect from 'react-region-select';
import useEventsStore from '../../store/EventsStore';
import { XCircleFill } from 'react-bootstrap-icons';
import '../../utils/webRTC/ump-player-interleave';

const TimelineControlsLive = ({
  properties,
  showFetchImageGrid,
  hideFetchImageGrid,
  callCountAPI,
  deviceId,
  isLicenseExpired,
  deviceInformation,
  muteAudio,
}) => {
  const { isEdgeRecording } = properties;
  const remoteStreamAudio = useSelector(getRemoteStreamAudio);
  const streamLoader = useSelector(getStreamLoader);
  const [deviceDetails, setDeviceDetails] = useState(deviceInformation);
  const mqttConnection = useSelector(getMQTTConnection);
  const accountId = useSelector(getAccountId);
  const platformDetails = useSelector(getPlatformInfo);
  const offerStatus = useSelector(getOfferRecivedStatus);
  const dispatch = useDispatch();
  const intervalRef = useRef();
  const playerRef = useRef();
  const flag = useRef(false);
  const remoteAudioRef = useRef();
  // Grid related state
  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegions] = useState();
  const [finalCoordinates, setFinalCoordinates] = useState({});
  const [isRegionChanging, setIsRegionChanging] = useState(true);
  const [videoWidth, setVideoWidth] = useState();
  const [refResolution, setRefResolution] = useState();
  const reconnectIntervalRef = useRef();
  const reconnectLiveStream = useRef(false);
  const [elementData, setElementData] = useState();
  const {
    setSnapshotCoordinate,
    setSelectedRegion,
    getSelectedRegion,
    setRegion,
    getRegion,
  } = useEventsStore();
  const player = document.querySelector('ump-player');
  const videoElementLive = isEdgeRecording
    ? document.getElementById(`live-ump-player-test${deviceId}${deviceId}`)
    : document.getElementById(
        `livestream-ump-player-test${deviceId}${deviceId}`,
      );

  useEffect(() => {
    setElementData({
      videoWidth: videoElementLive?.videoWidth,
      videoHeight: videoElementLive?.videoHeight,
    });
  }, [
    videoElementLive,
    videoElementLive?.videoWidth,
    videoElementLive?.videoHeight,
    videoElementLive?.readyState,
  ]);

  useEffect(() => {
    if (offerStatus) {
      clearInterval(intervalRef?.current);
      clearInterval(reconnectIntervalRef?.current);
    } else {
      clearInterval(reconnectIntervalRef?.current);
      reconnectIntervalRef.current = setInterval(() => {
        flag.current = false;
        reconnectLiveStream.current = !reconnectLiveStream.current;
      }, 10000);
    }
  }, [offerStatus]);

  useEffect(() => {
    dispatch(setOfferrecived(false));

    return () => {
      clearInterval(intervalRef?.current);
      clearInterval(reconnectIntervalRef?.current);
      dispatch(setOfferrecived(false));
    };
  }, []);

  useEffect(() => {
    try {
      if (!isEdgeRecording && remoteStreamAudio && remoteStreamAudio !== null) {
        const remoteAudio = remoteAudioRef.current;
        remoteAudio.srcObject = remoteStreamAudio;
      }
    } catch (error) {}
  }, [remoteStreamAudio]);

  useEffect(() => {
    const deviceStatus = Utils.getDeviceStatus(
      deviceInformation?.deviceStatus,
      deviceInformation?.connectionStatus,
    );
    if (
      deviceInformation &&
      deviceStatus?.toLowerCase() !==
        deviceDetails?.connectionStatus?.toLowerCase()
    ) {
      setDeviceDetails(deviceInformation);
    }
  }, [JSON.stringify(deviceInformation)]);

  useEffect(() => {
    dispatch(setRemoteStream(null));
    dispatch(setIsActiveStream(false));
    dispatch(setRemoteStreamAudio(null));
    const displayDeviceStatus = Utils.getDeviceStatus(
      deviceDetails?.deviceStatus,
      deviceDetails?.connectionStatus,
    );
    if (mqttConnection) {
      if (
        !offerStatus &&
        displayDeviceStatus?.toLowerCase() ===
          constants.DEVICES_ONLINE_CONNECTION_STATUS
      ) {
        Utils.vmsLogger().log('LiveStream: Initial call for offer send');
        publishWithMQTT(
          platformDetails.mqtt,
          platformDetails.p2p_server,
          deviceDetails,
          accountId,
          { isEdgeRecording },
        );
        if (!flag.current) {
          flag.current = true;
          playerRef?.current?.play(null, deviceId);
          playerRef?.current?.addEventListener('error', (err) => {
            if (err.detail?.message?.startsWith('Not Supported mimeType')) {
              const codecObj = {
                id: deviceId,
                isCodecNotSupport: true,
              };
              dispatch(setCodecNotSupported(codecObj));
              console.error(
                'LiveStream: Not Supported mimeType, retrying to play',
              );
            }
          });
        }
        // const id = setInterval(() => {
        //   Utils.vmsLogger().log('LiveStream: Retrying for offer send');
        //   publishWithMQTT(
        //     platformDetails.mqtt,
        //     platformDetails.p2p_server,
        //     deviceDetails,
        //     accountId,
        //   );
        // }, 10000);
        // intervalRef.current = id;
      }
    } else {
      flag.current = false;
      clearInterval(reconnectIntervalRef?.current);
    }
  }, [
    mqttConnection,
    isLicenseExpired,
    deviceDetails?.connectionStatus,
    accountId,
    isEdgeRecording,
    dispatch,
    deviceDetails,
    offerStatus,
    platformDetails.mqtt,
    platformDetails.p2p_server,
    deviceId,
    reconnectLiveStream.current,
  ]);

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    if (selectedRegion && refResolution && videoWidth > 0) {
      const divResolutionWidth = document.getElementById(
        `canvas${deviceId}${deviceId}`,
      ).offsetWidth;
      const divResolutionHeight = document.getElementById(
        `canvas${deviceId}${deviceId}`,
      ).offsetHeight;
      const proportionWidth = parseInt(refResolution[0]) / divResolutionWidth; // guess ref resolution is 2592 x 1520
      const proportionHeight = parseInt(refResolution[1]) / divResolutionHeight; // guess ref resolution is 2592 x 1520

      const bottomLeftX =
        proportionWidth * ((divResolutionWidth / 100) * selectedRegion[0].x);
      const bottomLeftY =
        proportionHeight *
        ((divResolutionHeight / 100) *
          (selectedRegion[0].y + selectedRegion[0].height));
      const topRightX =
        proportionWidth *
        ((divResolutionWidth / 100) *
          (selectedRegion[0].x + selectedRegion[0].width));
      const topRightY =
        proportionHeight * ((divResolutionHeight / 100) * selectedRegion[0].y);

      const finalCoordinateObj = {
        bottomLeftX,
        bottomLeftY,
        topRightX,
        topRightY,
      };
      setFinalCoordinates(finalCoordinateObj);
    }
  }, [selectedRegion, videoWidth]);

  useEffect(() => {
    if (!isRegionChanging && Object.keys(finalCoordinates).length > 0) {
      setSnapshotCoordinate(finalCoordinates);
      callCountAPI();
    } else {
      if (!isRegionChanging) {
        callCountAPI();
      }
    }
  }, [isRegionChanging, finalCoordinates]);

  useEffect(() => {
    if (deviceId && deviceDetails) {
      const selectedChildDevice = deviceDetails;
      if (deviceDetails) {
        const referenceResolution =
          selectedChildDevice?.properties?.['reference-resolution'];
        if (referenceResolution) {
          setRefResolution(referenceResolution.split('x'));
        }
      }
    }
  }, [deviceDetails]);

  useEffect(() => {
    if (player && !streamLoader && muteAudio) {
      player?.mute();
    }
  }, [player, streamLoader]);

  useEffect(() => {
    if (showFetchImageGrid === false) {
      setSelectedRegions(null);
      setRegions([]);
      setFinalCoordinates({});
    } else {
      const ele = document.getElementById(`canvas${deviceId}${deviceId}`);
      if (ele) {
        const divResolutionWidth = ele.offsetWidth;
        setVideoWidth(divResolutionWidth);
      }
    }
  }, [showFetchImageGrid, elementData]);

  const handleWindowSizeChange = () => {
    try {
      const divElement = document.getElementById(
        `canvas${deviceId}${deviceId}`,
      );
      if (divElement) {
        const divResolutionWidth = divElement.offsetWidth;
        setVideoWidth(divResolutionWidth);
      }
    } catch (err) {
      Utils.vmsLogger().log(err);
    }
  };

  const resetObjects = () => {
    hideFetchImageGrid();
    setSelectedRegions(null);
    setSelectedRegion(null);
    setRegions([]);
    setRegion([]);
    setFinalCoordinates({});
    setSnapshotCoordinate({});
  };

  const onChange = (regions) => {
    setRegions(regions);
    setSelectedRegions(regions);
    setSelectedRegion(regions);
    setRegion(regions);
    handleRemoveSelected();
  };

  const handleRemoveSelected = () => {
    if (selectedRegion) {
      const updatedRegions = regions?.filter(
        (region) => region !== selectedRegion,
      );
      setRegions(updatedRegions);
      setSelectedRegions(null);
    }
  };

  const regionRenderer = (regionProps) => {
    if (!regionProps.isChanging) {
      if (isRegionChanging) {
        setIsRegionChanging(false);
      }
      return (
        <div class="iconset">
          <XCircleFill
            size={24}
            onClick={resetObjects}
            style={{ cursor: 'pointer' }}
          />
        </div>
      );
    } else {
      setIsRegionChanging(true);
    }
  };

  return (
    <div
      className="remote-view-wrapper"
      style={{ position: 'relative', touchAction: 'none' }}
      id="remote-view-wrapper"
    >
      {accountId &&
        deviceId &&
        deviceDetails?.deviceId &&
        mqttConnection &&
        !isLicenseExpired && (
          <ump-player
            ref={playerRef}
            id={`ump-player-test${deviceId}${deviceId}`}
            hostname="192.168.125.100"
            datachannel="192.168.125.9:8080"
            username="admin"
            password=""
            channel={1}
            device="camera"
            https={false}
            audiosync={true}
            secure={false}
            profile="H.264"
            profileusage="Network"
            controls
            port={80}
            deviceId={deviceId}
          />
        )}
      {!isEdgeRecording && (
        <audio
          id="audio"
          ref={remoteAudioRef}
          autoPlay={true}
          playsInline={true}
          controls={false}
          muted={muteAudio}
        ></audio>
      )}
      <canvas
        id={`canvas${deviceId}${deviceId}`}
        style={{ position: 'absolute', height: '-webkit-fill-available' }}
        width={elementData?.videoWidth}
        height={elementData?.videoHeight}
      ></canvas>
      {showFetchImageGrid && (
        <div className="region-select-main">
          <RegionSelect
            id="region-select"
            maxRegions={1}
            regions={getRegion()}
            selectedRegion={getSelectedRegion()}
            regionStyle={{
              background: `${getComputedStyle(
                document.documentElement,
              ).getPropertyValue('--brand_white')}70`,
              zIndex: 70,
            }}
            onChange={onChange}
            regionRenderer={regionRenderer}
            className="region-select-main-outer"
            style={{
              width: videoWidth,
            }}
            constraint={true}
          >
            <div class="grid-image-fetch"></div>
          </RegionSelect>
        </div>
      )}
    </div>
  );
};

export default TimelineControlsLive;
